export default __webpack_public_path__ + "images/O1.27b6cba.png";